import type { ApiFieldErrors } from '../types/phoneNumber.types'

export class ApiError extends Error {
  fieldErrors?: ApiFieldErrors
  /** Raw response body from the failing API call (for structured payloads). */
  responseData?: unknown

  constructor(
    message: string,
    fieldErrors?: ApiFieldErrors,
    responseData?: unknown,
  ) {
    super(message, { cause: fieldErrors })
    this.name = 'ApiError'
    this.fieldErrors = fieldErrors
    this.responseData = responseData
  }
}
